import { Navigate, Outlet } from "react-router-dom";

import { Sidebar } from "./sidebar";
import { useUser } from "./auth-provider";
import { Loader } from "./loader";

export function AppLayout() {
	const { isLoggedIn, isLoading } = useUser();

	if (isLoading) {
		return <Loader />;
	}

	if (!isLoggedIn) {
		return <Navigate to="/login" replace />;
	}

	return (
		<div className="grid grid-rows-1 h-full">
			<div className="w-14 fixed inset-y-0 bg-[#f5f5f5] z-50">
				<Sidebar />
			</div>
			<main className="ml-14 overflow-auto min-w-[300px]">
				<Outlet />
			</main>
		</div>
	);
}

export function DefaultLayout() {
	const { isLoggedIn, isLoading } = useUser();

	if (isLoading) {
		return <Loader />;
	}

	if (isLoggedIn) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}
